module.exports = __webpack_public_path__ + "static/media/libbg.bb270884.jpg";